module.exports = __webpack_public_path__ + "public/media/AKL MAMA.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/lOGO PNG/AKL MAMA.png
// module id = ./images/partners/lOGO PNG/AKL MAMA.png
// module chunks = 0